import { holidaysList } from '../constants/holidaysList';
import { isNextWorkingDay } from '../../shared/services/workingDays/isWorkingDay';
import type { Field } from '../types';
import { isCheckboxField, isDateField, isNumberField } from '../types/guards';

export function applyRules(rule: string, value: string, field: Field): string {
  switch (rule) {
    case 'required':
      if (
        !value ||
        value === '' ||
        (isNumberField(field) && Number(value) === 0) ||
        (isCheckboxField(field) && value.length === 0)
      ) {
        return 'required';
      }
      break;
    case 'number':
      if (!Number.isInteger(+value)) {
        return 'number';
      }
      break;
    case 'email':
      if (!/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/.test(value)) {
        return 'email';
      }
      break;
    case 'min':
      if (isNumberField(field) && field.min !== undefined && Number(value) < field.min) {
        return 'min';
      }
      break;
    case 'max':
      if (isNumberField(field) && field.max !== undefined && Number(value) > field.max) {
        return 'max';
      }
      break;
    case 'date':
      if (isDateField(field) && !/[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
        return 'date';
      }
      break;
    case 'twoLetters':
      if (!/[A-Z]{2}/.test(value)) {
        return 'twoLetters';
      }
      break;
    case 'nextWorkingDay':
      if (!isNextWorkingDay(value, holidaysList)) {
        return 'nextWorkingDay';
      }
      break;

    default:
      return '';
  }
  return '';
}
